export class LiquidacaoEnvio {
    codigoProjeto: string;
    anoExercicio: number;
    numeroEmpenho: string;
    codigoCredor: number;
    cnpjCpfCredor: string;
    nomeCredor: string;
    numeroProcessoSEI: string;
    enviada: boolean;
    valor: number;
    numeroObservacao: string;
    codigoBancoCredor:number;
    nomeBancoCredor:string
    codigoAgenciaCredor:string;
    numeroContaBancariaCredor:number;
    digitoContaBancariaCredor:string;
    tipoContaCredor: number;
    nomeFormaRecebimentoCredor:string;    
    nomeTipoConsignataria:string;
    cnpjCpfCredorConsignataria:string;
    nomeFormaRecebimentoCredorConsignataria:string;
    dataVencimentoDespesaConsignataria: Date;
    valorRetidoConsignacao:number;
    codigoSubElementoFormatado:string;
    valorSubElementoDespesa:number;
    consignatarias:any[];

    constructor () {

    }
}



// WEBPACK FOOTER //
// ./src/app/models/pagamento/liquidacao-envio.ts